import propTypes from 'prop-types';
import React, { useContext, useEffect, useReducer } from 'react';
import { GREEN_TICK, OPEN_POP_UP_IMAGE } from '../../config/constants/images';
import { LINK_CONTACT_US } from '../../config/links/links';
import {
  CREDIT_REFUND_BUTTON_TEXT,
  VOUCHER_PROTECTED_CUSTOMER_SERVICE,
  CUSTOMER_SERVICE_WHATSAPP_BUTTON_TEXT,
  OR_TEXT,
  CUSTOMER_SERVICE_EMAIL_BUTTON_TEXT,
  CHOOSE_REFUND_REASON_TEXT,
  VOUCHER_REFUND_SUCCESS_MESSAGE,
  VOUCHER_REFUND_CONFIRMATION_TEXT,
  REFUND_BUTTON_TEXT,
  CANCEL_REFUND_TEXT,
  CASH_REFUND_DISCLAMER_TEXT,
  VOUCHER_REFUND_ERROR_TEXT,
  MAIL_TO_CUSTOMER_SERVICE_LINK,
} from '../../config/text/text';
import { symbolFromCurrency } from '../../helpers/currency';
import {
  checkProtectMyVoucherStatus,
  getVoucherRefundData,
  voucherRefundHandle,
} from '../../helpers/vouchers';
import ThemeContext from '../../providers/ThemeProvider';
import ButtonAsLink from '../_generic/button/ButtonAsLink';
import CTAButton from '../_generic/button/CTAButton';
import Modal from '../_generic/modal/Modal';
import Paragraph from '../_generic/paragraph/Paragraph';
import CashRefund from './CashRefund';
import VoucherRefundReasonList from './VoucherRefundReasonList';

const initialState = {
  confirmModalOpen: false,
  dropDownText: '',
  error: false,
  isCashRefund: '',
  modalOpen: false,
  refundSuccessful: false,
  selectedRefundOption: '',
  voucherAvailableForRefund: false,
  voucherRefundData: undefined,
  voucherRefunded: false,
  voucherRefundNotAvailable: false,
};

function reducer(state, action) {
  switch (action.type) {
    case 'OPEN_MODAL':
      return { ...state, modalOpen: true };
    case 'CLOSE_MODAL':
      return { ...state, modalOpen: false };
    case 'SET_DROPDOWN_TEXT':
      return { ...state, dropDownText: action.payload };
    case 'SET_VOUCHER_REFUND_DATA':
      return { ...state, voucherRefundData: action.payload };
    case 'SET_SELECTED_REFUND_OPTION':
      return { ...state, selectedRefundOption: action.payload };
    case 'SET_IS_CASH_REFUND':
      return { ...state, isCashRefund: action.payload };
    case 'OPEN_CONFIRM_MODAL':
      return { ...state, confirmModalOpen: true };
    case 'CLOSE_CONFIRM_MODAL':
      return { ...state, confirmModalOpen: false };
    case 'SET_REFUND_SUCCESSFUL':
      return { ...state, refundSuccessful: true };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    case 'REFUND_NOT_AVAILABLE':
      return { ...state, voucherRefundNotAvailable: true };
    case 'REFUND_AVAILABLE':
      return { ...state, voucherAvailableForRefund: true };
    case 'VOUCHER_REFUNDED':
      return { ...state, voucherRefunded: true };
    default:
      return state;
  }
}

const ProtectMyVoucherDropdown = ({
  voucherImage,
  voucherText,
  protectMyVoucherStatus,
  dropdownText,
  voucherCopy,
  voucherDetails,
  mutate,
}) => {
  const theme = useContext(ThemeContext);
  const [state, dispatch] = useReducer(reducer, initialState);

  const handleRefundSelectedOption = (value) => {
    dispatch({ payload: false, type: 'SET_ERROR' });
    dispatch({ payload: value, type: 'SET_SELECTED_REFUND_OPTION' });
  };
  useEffect(() => {
    checkProtectMyVoucherStatus(protectMyVoucherStatus, dispatch);
  }, [protectMyVoucherStatus]);

  useEffect(() => {
    if (state.voucherRefundNotAvailable)
      dispatch({
        payload: dropdownText[protectMyVoucherStatus],
        type: 'SET_DROPDOWN_TEXT',
      });
  }, [dropdownText, state.voucherRefundNotAvailable, protectMyVoucherStatus]);
  const onClose = () => dispatch({ type: 'CLOSE_MODAL' });
  const onConfirmModalClose = () => dispatch({ type: 'CLOSE_CONFIRM_MODAL' });

  const handleDropDownClickEvent = async () => {
    //  check if the value in voucher code is present in state, if yes return that, otherwise call the api to get the value
    if (
      state.voucherRefundData === undefined &&
      state.voucherAvailableForRefund
    ) {
      const data = await getVoucherRefundData(voucherDetails.voucherCode);

      dispatch({ payload: data, type: 'SET_VOUCHER_REFUND_DATA' });
    }
    if (!state.voucherRefunded) dispatch({ type: 'OPEN_MODAL' });
  };
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleDropDownClickEvent();
    }
  };

  const openEmail = () => {
    window.location.href = MAIL_TO_CUSTOMER_SERVICE_LINK;
  };
  const handleRefund = async () => {
    try {
      const data = await voucherRefundHandle(
        voucherDetails.voucherCode,
        state.selectedRefundOption,
        state.isCashRefund,
      );
      if (data) {
        onConfirmModalClose();
        await mutate();
        dispatch({ type: 'SET_REFUND_SUCCESSFUL' });
        setTimeout(() => {
          onClose();
        }, 3_000);
      }
    } catch {
      console.warn('error occured');
    }
  };

  const handleConfirmRefundModal = (isCashRefundSelected) => {
    if (state.selectedRefundOption) {
      dispatch({ payload: isCashRefundSelected, type: 'SET_IS_CASH_REFUND' });
      dispatch({ type: 'OPEN_CONFIRM_MODAL' });
    } else {
      dispatch({ payload: true, type: 'SET_ERROR' });
    }
  };
  const openContactLink = () => {
    window.open(LINK_CONTACT_US);
  };

  return (
    <div className="extension">
      <div
        className="container"
        onClick={handleDropDownClickEvent}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
      >
        <div className="left-content">
          <img
            alt="protect my voucher"
            className="extension-icon"
            src={voucherImage}
          />
          <span className="extension-content">
            {voucherText[protectMyVoucherStatus]}
          </span>
        </div>
        {!state.voucherRefunded && (
          <div className="right-content">
            <img alt="open pop up" src={OPEN_POP_UP_IMAGE} />
          </div>
        )}
      </div>
      {state.modalOpen && (
        <Modal isOpen={state.modalOpen} onClose={onClose}>
          {!state.refundSuccessful && (
            <div
              className={
                state.voucherRefundData?.contactCustomerServices
                  ? 'flex-column'
                  : ''
              }
            >
              <Paragraph textAlign="center" type={'title'}>
                <strong>{voucherCopy.heading}</strong>
              </Paragraph>
              <Paragraph textAlign="center" type={'subtitle'}>
                <strong>{voucherCopy.subHeading}</strong>
              </Paragraph>
              {state.dropDownText && !state.voucherRefundData && (
                <Paragraph textAlign="center">{state.dropDownText}</Paragraph>
              )}
              {state.voucherRefundData &&
                Object.keys(state.voucherRefundData)?.length > 0 &&
                !state.voucherRefundData?.contactCustomerServices && (
                  <>
                    <div className="align-cash-section">
                      <Paragraph textAlign={'left'}>
                        {CHOOSE_REFUND_REASON_TEXT}
                      </Paragraph>
                      {state.error && (
                        <Paragraph
                          color={theme.colors.errorboxtext}
                          textAlign={'left'}
                        >
                          {VOUCHER_REFUND_ERROR_TEXT}
                        </Paragraph>
                      )}
                      <VoucherRefundReasonList
                        handleSelectedOption={handleRefundSelectedOption}
                        refundReasons={state.voucherRefundData.refundReasons}
                        selectedRefundOption={state.selectedRefundOption}
                      />
                    </div>
                    <div className="flex-item">
                      <div className="align-refund">
                        <Paragraph textAlign={'center'}>
                          {voucherCopy.immediateRefundText}
                        </Paragraph>
                        <CTAButton
                          className={'credit-refund-button'}
                          onClick={() => handleConfirmRefundModal(false)}
                          primaryAction={false}
                        >
                          {`${
                            CREDIT_REFUND_BUTTON_TEXT[
                              process.env.NEXT_PUBLIC_BRAND
                            ]
                          } ${symbolFromCurrency(
                            state.voucherRefundData.currency,
                          )}${state.voucherRefundData.amount}`}
                        </CTAButton>
                      </div>
                      {state.voucherRefundData.cashRefundAvailable && (
                        <>
                          <CashRefund
                            amount={state.voucherRefundData.amount}
                            currency={state.voucherRefundData.currency}
                            handleCashRefund={handleConfirmRefundModal}
                          />
                        </>
                      )}
                    </div>
                    {state.voucherRefundData?.cashRefundAvailable && (
                      <div className="margin-top">
                        <Paragraph>{CASH_REFUND_DISCLAMER_TEXT}</Paragraph>
                      </div>
                    )}
                  </>
                )}
              {state.voucherRefundData?.contactCustomerServices && (
                <div className="align-refund-customer-service">
                  <Paragraph textAlign={'center'}>
                    {VOUCHER_PROTECTED_CUSTOMER_SERVICE}
                  </Paragraph>
                  <CTAButton
                    className={'customer-service-button'}
                    onClick={openContactLink}
                    primaryAction={false}
                  >
                    {CUSTOMER_SERVICE_WHATSAPP_BUTTON_TEXT}
                  </CTAButton>
                  <Paragraph textAlign={'center'}>{OR_TEXT}</Paragraph>
                  <ButtonAsLink
                    href="mailto:cs@dealhelp.co.uk"
                    onClick={openEmail}
                  >
                    {CUSTOMER_SERVICE_EMAIL_BUTTON_TEXT}
                  </ButtonAsLink>
                </div>
              )}
            </div>
          )}
          {state.refundSuccessful && (
            <div className="flex-column">
              <div className="tick-container">
                <img
                  alt="green success tick"
                  className="tick-icon"
                  src={GREEN_TICK}
                />
              </div>
              <div className="margin-top width">
                <Paragraph fontSize={'1.1em'} textAlign={'left'}>
                  {VOUCHER_REFUND_SUCCESS_MESSAGE}
                </Paragraph>
              </div>
            </div>
          )}
        </Modal>
      )}
      {state.confirmModalOpen && (
        <Modal isOpen={state.confirmModalOpen} onClose={onConfirmModalClose}>
          <Paragraph fontSize={'15px'} textAlign={'center'}>
            {VOUCHER_REFUND_CONFIRMATION_TEXT}
          </Paragraph>
          <div className="flex-item">
            <div className="width-set">
              <CTAButton
                className={'cancel-button'}
                onClick={() => onConfirmModalClose()}
                primaryAction={false}
              >
                {CANCEL_REFUND_TEXT}
              </CTAButton>
            </div>
            <div className="width-set">
              <CTAButton
                className={'refund-button'}
                onClick={() => handleRefund()}
                primaryAction={false}
              >
                {REFUND_BUTTON_TEXT}
              </CTAButton>
            </div>
          </div>
        </Modal>
      )}
      <style jsx>
        {`
          .extension {
            background-color: ${state.voucherRefunded
              ? 'rgba(255, 255, 255, 0.7)'
              : 'rgba(255, 255, 255, 0.9)'};
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
            font-size: 13px;
            padding: 8px 8px 8px 0px;
            position: absolute;
            width: 100%;
            border-radius: 2%;
          }
          .container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            cursor: ${state.voucherRefunded ? 'default' : 'pointer'};
            padding-left: 2%;
          }
          .left-content {
            display: flex; /* Create a nested flex container for left content */
            align-items: left; /* Vertically center the left content */
          }
          .right-content {
            display: flex; /* Create a nested flex container for left content */
            align-items: right; /* Vertically center the right content */
            width: 10%;
            height: 20px;
          }
          .align-refund {
            justify-content: center;
            text-align: center;
            width: ${state.voucherRefundData?.cashRefundAvailable
              ? '50%'
              : '100%'};
          }
          .align-refund-customer-service {
            justify-content: center;
            text-align: center;
          }
          .flex-item {
            display: flex;
            flex-direction: row;
          }
          .width-set {
            width: 50%;
            align-items: center;
            display: flex;
            justify-content: center;
          }
          .width {
            width: 100%;
            align-items: center;
            display: flex;
            justify-content: center;
          }
          .icon {
            width: 30%;
            align-item: center;
            justify-content: center;
          }
          .tick-container {
            padding: 30px 0;
            text-align: center;
          }
          .flex-column {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .extension-content {
            color: ${theme.commoncolors.greycharcoal};
            position: relative;
          }
          .extension-icon {
            height: 21px;
            margin-right: 5px;
          }
          .tick-icon {
            height: 100px;
          }
          .expander {
            background-color: white;
            box-shadow: ${theme.colors.dropshadow} 0 3px 6px;
            margin-top: 1.5%;
            margin-left: -2.4%;
            min-height: 100px;
            width: 100%;
            overflow: auto;
            padding: 12px 10px 5px 12px;
            position: absolute;
          }
          .align-cash-section {
            text-align: center;
            justify-content: center;
            margin-top: 8%;
            font-size: 12px;
          }
          .margin-top {
            margin-top: 2%;
          }
          .sub-title {
            margin-bottom: 1px;
            font-size: 13px;
            text-align: center;
          }
          .expander-open {
            display: block;
            z-index: 1;
          }
          .expander-close {
            display: none;
          }
          /* Desktop version*/
          @media (min-width: ${theme.breakpoints.lgUp}) {
            .extension {
              width: calc(100% / 3 - 10px);
            }
            .expander {
              margin-top: 4%;
              margin-left: -4%;
            }
            .width-set {
              width: 34%;
              margin-left: 9%;
            }
            .container {
              padding-left: 4%;
            }
            .align-cash-section {
              font-size: 14px;
            }
          }
        `}
      </style>
    </div>
  );
};

ProtectMyVoucherDropdown.propTypes = {
  dropdownText: propTypes.object,
  mutate: propTypes.func,
  protectMyVoucherStatus: propTypes.string,
  voucherCopy: propTypes.object,
  voucherDetails: propTypes.object,
  voucherImage: propTypes.string,
  voucherText: propTypes.object,
};

export default ProtectMyVoucherDropdown;
